import {type ThemeOptions} from '@mui/material';
import {customMuiComponents} from './getCustomMuiComponents';
import {Theme} from 'interfaces';
import {darkPalette} from './darkPalette';
import {lightPalette} from './lightPalette';
import typography from './typography';

export const themOptions: (theme: Theme) => ThemeOptions = (theme: Theme) => {
  return {
    palette: theme === Theme.light ? lightPalette : darkPalette,
    typography,
    zIndex: {
      appBar: 1200,
      drawer: 1100,
      modal: 1300,
      tooltip: 1400,
    },
    components: customMuiComponents,
  };
};
